import { useEffect, useState } from 'react';
import { meta } from '../../../constants';

type LinkPreviewType = {
  cover: string;
  description: string;
  images: string[];
  title: string;
  video: string;
  videoType: string;
};

const SHORT_LINK_LIST = ['https://t.co'];
const MAX_REDIRECT_DEPTH = 2;

export const usePreviewFetch = (
  url: string | undefined
): LinkPreviewType | null => {
  const [data, setData] = useState<LinkPreviewType | null>(null);

  // As of 01.04.2025, our parser cannot parse Twitter previews anymore
  const isTwitterLink = checkIfTwitterLink(url);

  useEffect(() => {
    let cancelled = false;

    if (!url) return;

    async function fetchData(currentUrl: string, depth = 0) {
      const previewURL = new URL(`${meta.storageURL}/preview`);
      previewURL.searchParams.set('q', currentUrl);

      try {
        const response = await fetch(previewURL);
        const previewData: LinkPreviewType = await response.json();

        const shouldFollowRedirect =
          previewData.cover &&
          SHORT_LINK_LIST.some((short) =>
            previewData.cover.startsWith(short)
          ) &&
          previewData.title &&
          previewData.title !== currentUrl;

        if (!cancelled) {
          if (shouldFollowRedirect && depth < MAX_REDIRECT_DEPTH) {
            return fetchData(previewData.title, depth + 1);
          }
          setData(previewData);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to fetch preview:', error);
        }
      }
    }

    fetchData(url);

    return () => {
      cancelled = true;
    };
  }, [url]);

  if (Array.isArray(data) || isTwitterLink) {
    return null;
  }

  return data;
};

function checkIfTwitterLink(link?: string) {
  if (!link) {
    return false;
  }

  return (
    link.startsWith('https://twitter.com/') || link.startsWith('https://x.com/')
  );
}
